import AssignedVehicleItem from './AssignedVehicleItem';

export default AssignedVehicleItem;
